export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-100 border-t border-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg font-heading">
                妖
              </span>
              <span className="text-lg font-heading font-bold text-foreground-900">
                妖精漫画网
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              妖精漫画网是国内领先的漫画在线阅读平台，提供海量奇幻、魔幻、萌系漫画免费阅读服务。
              支持下拉式全集追更，安全快速访问，为您打造沉浸式的奇妙漫画世界。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">网站首页</a></li>
              <li><a href="#about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">关于妖精漫画</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">热门排行</a></li>
              <li><a href="#index" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">专题合集</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">常用链接</h4>
            <ul className="space-y-2.5">
              <li><a href="#faq" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">常见问题</a></li>
              <li><a href="#updates" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">最新动态</a></li>
              <li><a href="#contact" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">联系我们</a></li>
              <li><a href="#app" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">移动阅读</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">友情链接</h4>
            <ul className="space-y-2.5">
              <li>
                <span className="text-sm text-foreground-400">友情链接交换中</span>
              </li>
              <li>
                <span className="text-sm text-foreground-400">欢迎同类站点联系</span>
              </li>
              <li>
                <span className="text-sm text-foreground-400">漫画爱好者社区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-300/50 pt-6">
          <div className="mb-4">
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">合作伙伴</h4>
            <div className="flex flex-wrap gap-4">
              <span className="text-sm text-foreground-400">合作伙伴招募中</span>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2020 - 2026 妖精漫画网 版权所有
            </p>
            <p className="text-xs text-foreground-400">
              海量奇幻魔幻萌系漫画免费看 · 下拉式全集追更不断 · 安全快速体验奇妙漫画世界
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}